/**
 * Gets a CSS custom property value
 * @param propertyName - The CSS custom property name (e.g., "--brand-800")
 * @returns The computed value of the CSS custom property
 */
export function getCssVariable(propertyName: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(propertyName);
}
